import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { NoticeApi } from 'api';
import type { Notice } from 'api/methods/NoticeApi';

/**
 * [Notice] Query key 생성
 * --
 */
export const noticeQueryKeys = createQueryKeys('notice', {
  getNotice: (idx: number, params?: { [key: string]: string | number }) => [
    idx,
    params,
  ],
  getNotices: (params?: { [key: string]: string | number }) => [params],
});

/**
 * [Notice] 공지사항 전체 조회
 * --
 */
export const useGetNotices = (
  params?: { [key: string]: string | number },
  options?: UseQueryOptions<any, any>
) => {
  const data = useQuery({
    queryKey: noticeQueryKeys.getNotices(params).queryKey,
    queryFn: () => NoticeApi.getNotices(params),
    ...options,
  });
  return data;
};

/**
 * [Notice] 공지사항 상세 조회
 * --
 */
export const useGetNotice = (
  idx: number,
  params?: { [key: string]: string | number },
  options?: UseQueryOptions<any, any>
) => {
  const data = useQuery({
    queryKey: noticeQueryKeys.getNotice(idx, params).queryKey,
    queryFn: () => NoticeApi.getNotice(idx, params),
    ...options,
  });

  return data;
};

/**
 * [Notice] 공지사항 생성
 * --
 */
export const useCreateNotice = (body: Notice) => {
  const { mutateAsync: createNotice, ...result } = useMutation({
    mutationFn: (variables: Notice) => NoticeApi.createNotice(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { createNotice, ...result };
};

/**
 * [Notice] 공지사항 수정
 * --
 */
export const useUpdateNotice = (body: Notice) => {
  const { mutateAsync: updateNotice, ...result } = useMutation({
    mutationFn: (variables: Notice) => NoticeApi.updateNotice(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { updateNotice, ...result };
};

/**
 * [Notice] 공지사항 삭제
 * --
 */
export const useDeleteNotice = (idx: number) => {
  const { mutateAsync: deleteNotice, ...result } = useMutation({
    mutationFn: (variables: number) => NoticeApi.deleteNotice(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { deleteNotice, ...result };
};
